import type { WalletAccount } from '@dynamic-labs-sdk/client';

import type { SuiWalletAccount } from '../SuiWalletAccount.types';

/**
 * Type guard function to check if a wallet account is a Sui wallet account.
 *
 * @param walletAccount - The wallet account to check.
 * @returns True if the wallet account is a Sui wallet account, false otherwise.
 */
export const isSuiWalletAccount = (
  walletAccount: WalletAccount
): walletAccount is SuiWalletAccount => walletAccount.chain === 'SUI';
